module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared-components/power-bireport/power-bireport.component.scss
// module id = ./src/app/shared-components/power-bireport/power-bireport.component.scss
// module chunks = main